<template>
    <div class="relative rounded w-full">
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-5">
            <i class="far text-black w-5" :class="icon" aria-hidden="true"></i>
        </div>
        <input :type="type" 
               :placeholder="placeholder" 
               class="block w-full !pl-12 py-3 rounded-xl" 
               :class="{'bg-grey-100': color}" 
               @input="$emit('update:modelValue', $event.target.value)">
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
    name: "icon-input",
    props: {
        color: {
            type: String as () => "white" | "grey",
            default: "white"
        },
        icon: String,
        placeholder: String,
        type: String,
        modelValue: String
    }
});
</script>